import React, { useContext } from 'react';
import { Tabs, Tab, Stack } from '@mui/material';
import { GBENSContext } from './GBENSContainer';
import { StoreContext } from '../../components/Store';

const ReviewAndSubmitMenu = () => {
  const {
    setSubmitModalOpen,
    setDuplicateModalOpen,
    setCancelShipmentModalOpen,
    cancelOrDelete,
    isAmendable,
    setAmendShipmentModalOpen,
    showSubmitButton,
    isReadOnly,
    isLocked,
    allValid,
  } = useContext(GBENSContext);

  const { hasSufficientBalance } = useContext(StoreContext);

  const renderCancelOrDelete = () => {
    if (cancelOrDelete === 'cancel') {
      return <Tab label="Cancel Shipment" onClick={() => setCancelShipmentModalOpen(true)} disabled={isReadOnly} />;
    }
    if (cancelOrDelete === 'delete') {
      return <Tab label="Delete Shipment" onClick={() => setCancelShipmentModalOpen(true)} disabled={isReadOnly} />;
    }
    return null;
  };

  return (
    <Stack direction="row" gap={2} className="review-and-submit-menu-wrapper">
      <div className="review-and-submit-menu">
        <Tabs
          className="reiew-and-submit-menu-content"
          orientation="vertical"
          value={0}
          sx={{
            '& .MuiTabs-indicator': {
              display: 'none',
            },
          }}
        >
          <div className="review-and-submit-menu-header">Shipment Actions</div>
          {showSubmitButton && (
            <Tab
              label="Submit Shipment"
              onClick={() => setSubmitModalOpen(true)}
              disabled={isReadOnly || !allValid || isLocked || !hasSufficientBalance}
            />
          )}
          <Tab label="Duplicate this Shipment" onClick={() => setDuplicateModalOpen(true)} disabled={isReadOnly} />
          {isAmendable && (
            <Tab
              label="Amend Shipment"
              onClick={() => {
                setAmendShipmentModalOpen(true);
              }}
              disabled={isReadOnly}
            />
          )}
          {renderCancelOrDelete()}
        </Tabs>
      </div>
    </Stack>
  );
};

export default ReviewAndSubmitMenu;
